/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }*/


import Vue from 'vue'
import Router from 'vue-router'
import auth from "@/auth/authService";
 
Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          redirect: "/dashboard"
        },

        {
          path: "/dashboard",
          name: "dashboard-analytics",
          component: () => import("./modules/app/dashboard/Dashboard.vue"),
          meta: {
            rule: "editor",
            pageTitle: "Dashboard",
            authRequired: true
          }
        },
        {
          path: "/lrsearch",
          name: "LR Search",
          component: () => import("./modules/app/others/lrsearch.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "LR Search",
            breadcrumb: [
              { title: "Home", url: "/" },
              // { title: "LR Search" },
              { title: "LR Search", active: true }
            ]
          }
        },
        {
          path: "/master/parties",
          component: () =>
            import("./modules/app/masters/clients/ClientsList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Clients",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Parties" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/master/locations",
          component: () =>
            import("./modules/app/masters/locations/LocationsList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Locations",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Locations" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/master/branches",
          component: () =>
            import("./modules/app/masters/branches/branchesList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Branches",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Branches" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/master/content",
          component: () =>
            import(
              "./modules/app/masters/consignmenttype/consignementTypeList.vue"
            ),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Content",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Content" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/master/employees",
          component: () =>
            import("./modules/app/masters/employees/employeesList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Employees",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Employees" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/master/collectionagent",
          component: () =>
            import(
              "./modules/app/masters/collectionagent/collectionagentslist.vue"
            ),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Collection Agents",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Collection Agents" },
              { title: "View", active: true }
            ]
          }
        },

        {
          path: "entries/memo",
          component: () => import("./modules/app/entries/memo/memoList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Memos",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Memos" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "entries/lrs",
          component: () => import("./modules/app/entries/lr/lrList.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Lrs",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Lrs" },
              { title: "View", active: true }
            ]
          }
        },
        {
          path: "/transactions/freighreceipt",
          component: () =>
            import("./modules/app/transactions/freightreceipt.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Freight Receipt",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Transactions" },
              { title: "Freight Receipt Generate", active: true }
            ]
          }
        },
        {
          path: "/reports/dds",
          component: () => import("./modules/app/reports/dds.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "DDS ",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "DDS View", active: true }
            ]
          }
        },
        {
          path: "/reports/agentreport",
          component: () => import("./modules/app/reports/agentreport.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Agent Report",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Agent Report", active: true }
            ]
          }
        },
        {
          path: "/reports/consignmentreport",
          component: () => import("./modules/app/reports/pendingLrs.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Consignments Report",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Consignments Report", active: true }
            ]
          }
        },
        {
          path: "/reports/cashmemo",
          component: () => import("./modules/app/reports/cashMemo.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Cash Memo",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Reports" },
              { title: "Cash Memo", active: true }
            ]
          }
        },

        {
          path: "/utils/paymentupdate",
          component: () => import("./modules/app/Utils/paymentupdate.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "Payment Update",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Utils" },
              { title: "Payment Update", active: true }
            ]
          }
        },
        {
          path: "/utils/lrserial",
          component: () => import("./modules/app/Utils/lrserial.vue"),
          meta: {
            rule: "editor",
            authRequired: true,
            pageTitle: "LR Serial",
            breadcrumb: [
              { title: "Home", url: "/" },
              { title: "Utils" },
              { title: "LR Serial", active: true }
            ]
          }
        }
      ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // Util Pages
        // =============================================================================

        {
          path: "/login",
          name: "Login",
          component: () => import("@/modules/login/Login.vue"),
          meta: {
            rule: "editor",
            pageTitle: "Login"
          }
        },

        {
          path: "/error-404",
          name: "page-error-404",
          component: () => import("@/modules/utils/Error404.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/error-500",
          name: "page-error-500",
          component: () => import("@/modules/utils/Error500.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/not-authorized",
          name: "page-not-authorized",
          component: () => import("@/modules/utils/NotAuthorized.vue"),
          meta: {
            rule: "editor"
          }
        },
        {
          path: "/maintenance",
          name: "page-maintenance",
          component: () => import("@/modules/utils/Maintenance.vue"),
          meta: {
            rule: "editor"
          }
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/error-404"
    }
  ]
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})

// router.beforeEach((to, from, next) => {
  
        // if (to.path === "/login"  && (!auth.isAuthenticated())) {
        //     console.log("Next");
        //     return next();
        // }
//         if(to.meta.authRequired) {
//             if (!(auth.isAuthenticated() ) {
//               router.push({ path: '/login', query: { to: to.path } })
//             }
//           }
         
        // If auth required, check login. If login fails redirect to login page
        // if(to.meta.authRequired) {
        //   if (!auth.isAuthenticated() ) {
        //     router.push({ path: '/login', query: { to: to.path } })
        //   }
        // }

         
        // Specify the current path as the customState parameter, meaning it
        // will be returned to the application after auth
        // auth.login({ target: to.path });

        // return next()
        // Specify the current path as the customState parameter, meaning it
        // will be returned to the application after auth
        // auth.login({ target: to.path });

    // });

// });
const DEFAULT_TITLE="";
router.beforeEach((to, from, next) => {
  // console.log(to);
   Vue.nextTick(() => {
     document.title = 'SST | '+to.meta.pageTitle  || DEFAULT_TITLE;
   });
    if(to.meta.authRequired) {
        if (!auth.isAuthenticated() ) {
          router.push({ path: '/login', query: { to: to.path } })
        }
        else{
            return next();
        }
      }
    return next();
});

export default router
